<script>
import axios from "axios";

import helper from "./mixins/helper";
import validation from "./../../general/mixins/validation";
import npcity from "./../../general/inc/NPcity";
import npstreet from "./../../general/inc/NPstreet";
import npnumber from "./../../general/inc/NPnumber";

import phoneNumberInput from "./inc/phoneNumberInput";

import { countDiscountProductService } from "./services/countDiscountProductService";

import dateSelector from "./checkout/dateSelector";
import timeSelector from "./checkout/timeSelector";

export default {
    mixins: [
        helper,
        validation
    ],
    components: {
        npcity,
        npstreet,
        npnumber,
        'phone-number-input': phoneNumberInput,
        'date-selector': dateSelector,
        'time-selector': timeSelector
    },
    props: {
        user: {
            required: false
        },
        user_additional: {
            required: false
        },
        services: {
            required: true
        },
        stores: {
            required: true
        },
        options: {
            required: true
        }
    },
    data() {
        return {
            new_user_data: {
                fname: null,
                lname: null,
                mname: null,
                email: null,
                phone: null
            },
            order: {
                user: null,
                client_id: null,
                i_recipient: true,
                billing_status: 'not_payed',
                recipient: {
                    recipient_fname: null,
                    recipient_lname: null,
                    recipient_mname: null,
                    recipient_phone: null,
                    recipient_email: null
                },
                is_gift: false,
                delivery: {
                    delivery_type: null,
                    delivery_data: {
                        city: null,
                        city_json: null,
                        street: null, 
                        street_json: null,
                        house: null, 
                        entrence: null, 
                        apartment: null, 
                        delivery_date: null,
                        delivery_time_interval: null,
                        np_number: null,
                        np_number_json: null,
                        pickup_shop: null,
                        pickup_shop_title: null
                    }
                },
                payment: {
                    payment_type: null,
                    payment_data: null
                },
                promocode_number: null,
                order_comment: null,
                dont_call: false,
                products: [
                    {
                        "product_code": null,
                        "product_price": null,
                        "product_sale": null,
                        "product_qty": null
                    }
                ]
            },
            check: {
                phone: {
                    allow: false,
                    error: null,
                    number: null
                },
                recipient_phone: {
                    allow: true,
                    error: null,
                    number: null
                },
                account: {
                    allow: false
                },
                delivery: {
                    error: false
                },
                delivery_date: {
                    error: false
                },
                delivery_time_interval: {
                    error: false
                }
            },
            promocode: {
                message: null,
                sale_type: null,
                amount: null
            },
            allowRequest: true,
            login: true,
            bindProps: {
                mode: "international",
                enabledFlags: true,
                validCharactersOnly: true,
                inputOptions: {
                    placeholder: this.trans('general.phone'),
                    showDialCode: true
                }
            },
            deliveryAllowedTimes: {},
            deliveryDefault: true,
            deliveryNotAllCanBeDelivered: false,
            deliveryLoading: true
        }
    },
    created() {
    },
    beforeMount() {
    },
    mounted() {
        // Loader
        document.getElementById('checkout').classList.remove('loading');

        this.setUserContacts(this.user);
        this.setUserAdditional(this.user_additional);

        // Check true if user logged-in
        if (this.user) {
            this.check.account.allow = true;
            this.check.phone.allow = true;
        }
        // Set required fields for recipient
        this.prepareIRecipient();
        // Select default shop
        if (this.stores.length > 0) {
            this.order.delivery.delivery_data.pickup_shop = this.stores[0].id;
        }

        // For default unregistered user block
        this.requiredFieldsNew();
    },
    watch: {
        new_user_data: {
            handler(data){
                this.setRecepientContacts(data);
            },
            deep: true
        },
        order: {
            handler(data){
                this.order.delivery.delivery_data.pickup_shop_title = this.selectedStore;
            },
            deep: true
        },
        // 'order.delivery.delivery_type': function (type) {
        //     this.order.payment.payment_type = 'liqpay';
        // },
        // Set by storage
        user_data: function (data) {
            this.check.phone.allow = true;
            this.setUserContacts(data);
        },
        // Set by storage
        user_additional_data: function (data) {
            this.setUserAdditional(data);
        },
        delivery_only_kiev: function (data) {
            // Set default store
            if (data == true && this.stores.length > 0) {
                let current_store = this.stores.find(store => store.id == this.order.delivery.delivery_data.pickup_shop);
                if (current_store.delivery_kiev == false) {
                    let store = this.stores.find(store => store.delivery_kiev == true);
                    if (store) {
                        this.order.delivery.delivery_data.pickup_shop = store.id;
                    }
                }
            }
        },
        'order.delivery.delivery_type': {
            handler: function(newVal, oldVal) {           
                this.order.delivery.delivery_data.delivery_date = null;
                this.order.delivery.delivery_data.delivery_time_interval = null;
                
                this.getAllowedDeliveryDatesTimes(); // this.order.delivery.delivery_type
            },
            deep: true
        },
        '$store.state.cart.products': {
            handler(newVal, oldVal) {        
                this.getAllowedDeliveryDatesTimes();
            },
            deep: true
        },
        pay_after_confirm: function (data) {
            if (data !== true) {
                this.order.payment.payment_type = null;
            }
        }
    },
    computed: {
        delivery_only_kiev() {
            let product = this.$store.state.cart.products.find(product => product.delivery_only_kiev == 1);
            if (product) {
                return true;
            }
        },
        pay_after_confirm() {
            let product = this.$store.state.cart.products.find(product => product.pay_after_confirm == 1);
            if (product) {
                return true;
            }
        },
        cargo_branch() {
            let product = this.$store.state.cart.products.find(product => product.cargo_branch == 1);
            if (product) {
                console.log('Only cargo branches');
                return true;
            }
        },
        allowConfirm() { 
            if (this.cost > this.options.min_order_price &&
                this.allowRequest &&
                (!this.login || this.order.user)) {
                return true;
            } else {
                return false;
            }
        },
        kiev() {
            if (this.order.delivery.delivery_type == 'courier_kyiv') {
                return true;
            }
        },
        selectedStore() {
            for (var key in this.stores) {
                if (this.order.delivery.delivery_data.pickup_shop == this.stores[key].id) {
                    return this.stores[key].meta.checkout_title;
                }
            }
        },
        formCheckStatus() {
            for (var key in this.check) {
                if (!this.check[key].allow) {
                    return false;
                }
            }
            return true;
        },
        kiev_delivery() {
            return this.services.filter(obj => obj.slug == 'devliveryproduct')[0];
        },
        gift() {
            return this.services.filter(obj => obj.slug == 'giftbox')[0];
        },
        user_data: function () {
            if (this.$store.state.user) {
                this.check.account.allow = true;
                return this.$store.state.user;
            } else if (this.user) {
                return this.user;
            } else {
                return null;
            }
        },
        user_additional_data: function () {
            if (this.$store.state.user_additional) {
                return this.$store.state.user_additional;
            } else {
                return null;
            }
        },
        count: function () {
            let answer = 0;
            if (this.isset(this.$store.state.cart.data)) {
                this.$store.state.cart.data.forEach(element => {
                    answer = answer + element.count;
                });
            }
            return answer;
        },
        cost: function () {
            return this.eachCartProducts(
                (info_item, cart_item) => {
                    return info_item.price * cart_item.count;
                }
            );
        },
        cost_with_sale: function () {
            return this.eachCartProducts( // This method return summ of inner function returns
                (info_item, cart_item) => {

                    // Get user discount
                    let user_discount = 0;
                    if (this.user_data && this.user_data.discount && this.user_data.discount.value) {
                        user_discount = this.user_data.discount.value;
                    }

                    // Get promocode
                    let promocode_discount = 0;
                    if (this.promocode.amount > 0) {
                        promocode_discount = this.promocode.amount;
                    }

                    // Get product sale
                    let product_discount = info_item.sale_counted;
                    if (!product_discount) {
                        product_discount = 0;
                    }
                    // Count
                    let finaly_price = countDiscountProductService(info_item.price, user_discount, promocode_discount, product_discount);
                    
                    // Get price for selected quantity
                    let price = finaly_price * cart_item.count;
    
                    return price;
                }
            );
        },
        amount_payable: function () {

            let answer = this.cost_with_sale;

            // If check is gift
            if (this.order.is_gift) {
                answer = answer + Number(this.gift.price);
            }

            // If check curier_kiev
            if (this.order.delivery.delivery_type == 'courier_kyiv' && this.cost < this.options.free_kiev_shipping) {
                answer = answer + Number(this.kiev_delivery.price);
            }
            
            // If price > this.options.free_kiev_shipping (set in admin panel) free shiping
            // if (answer >= this.options.free_kiev_shipping && this.order.delivery.delivery_type == 'courier_kyiv') {
            //     if (answer - this.gift.price > this.options.free_kiev_shipping) {
            //         answer = answer - this.gift.price;
            //     }
            // }

            return answer;
        }
    },
    methods: {
        eachCartProducts(method) {
            let answer = 0;
            let cart = this.$store.state.cart.data;
            let info = this.$store.state.cart.products;
            if (info) {
                for (var i = 0; i < info.length; i++) {
                    for (var b = 0; b < cart.length; b++) {
                        if (cart[b].product == info[i].id) {
                            answer = answer + method(info[i], cart[b]);
                        }
                    }
                }
            }
            
            return answer;
        },
        shop_availability(store) {
            console.log(store.delivery_kiev);
            if (this.delivery_only_kiev && !store.delivery_kiev) {
                return false;
            }
            return true;
        },
        updateCitydata(data) {
            if (data) {
                this.order.delivery.delivery_data.city = data.Present;
            }
            this.order.delivery.delivery_data.city_json = data;
        },
        updateStreetdata(data) {
            if (data) {
                this.order.delivery.delivery_data.street = data.Present;
            }
            this.order.delivery.delivery_data.street_json = data;
        },
        updateNPNumberdata(data) {
            if (data) {
                this.order.delivery.delivery_data.np_number = data.Description;
            }
            this.order.delivery.delivery_data.np_number_json = data;
        },
        unregisteredPhoneError(error) {
            this.check.phone.error = error;
            this.check.phone.allow = error;
        },
        recipientPhoneError(error) {
            this.check.recipient_phone.error = error;
            this.check.recipient_phone.allow = error;
        },
        setOrderProducts() {
            let products = [];
            if (this.isset(this.$store.state.cart.products)) {
                this.$store.state.cart.products.forEach(element => {
                    let count = this.$store.state.cart.data.filter(obj => obj.product == element.id)[0];
                    let object = {
                        "product_code": element.product_code,
                        "product_price": element.price,
                        "product_sale": element.sale,
                        "product_qty": count
                    };
                    products.push(object);
                });
                this.order.products = products;
            }
        },
        // Set by props
        setUserAdditional(data) {
            if (this.isset(data)) {
                this.order.delivery.delivery_data.city = data.city;
                this.order.delivery.delivery_data.city_json = data.data ? data.data.city_json : null;
                this.order.delivery.delivery_data.street = data.street;
                this.order.delivery.delivery_data.street_json = data.data ? data.data.street_json : null;
                this.order.delivery.delivery_data.house = data.house;
                this.order.delivery.delivery_data.entrance = data.entrance;
                this.order.delivery.delivery_data.apartment = data.apartment;
                this.order.delivery.delivery_data.np_number = data.np_number;
                this.order.delivery.delivery_data.np_number_json = data.data ? data.data.np_number_json : null;
                this.order.delivery.delivery_data.pickup_shop = data.pickup_shop;
            }
        },
        // Set by props
        setUserContacts(data) {
            if (this.isset(data)) {
                this.order.user = data.id;
                this.order.client_id = data.client_id;

                this.new_user_data.fname = data.fname;
                this.new_user_data.lname = data.lname;
                this.new_user_data.mname = data.mname;
                this.new_user_data.email = data.email;
                this.new_user_data.phone = data.phone;
            }
        },
        setRecepientContacts(data) {
            if (!this.isset(data)) {
                data = this.new_user_data;
            }
            this.order.recipient.recipient_fname = data.fname;
            this.order.recipient.recipient_lname = data.lname;
            this.order.recipient.recipient_mname = data.mname;
            this.order.recipient.recipient_phone = data.phone;
            this.order.recipient.recipient_email = data.email;
        },
        openCart() {
            document.querySelector('.btn-cart.open-cart').click();
        },
        requiredFieldsNew() {
            if (this.$refs.user_new_data) {
                this.$refs.user_new_data.querySelectorAll(".checkelement").forEach(element => {
                    let name = element.getAttribute("name");
                    if (name == 'new_user_email') {
                        element.required = false;
                    } else {
                        element.required = true;
                    } 
                });
            }
            if (this.$refs.user_regular_data) {
                this.$refs.user_regular_data.querySelectorAll(".checkelement").forEach(element => {
                    element.required = false;
                });
            }
            this.check.account.allow = true;
            // Login or not registered tab
            this.login = false;
        },
        requiredFieldsRegular() {
            this.$refs.user_new_data.querySelectorAll(".checkelement").forEach(element => {
                element.required = false;
            });
            this.$refs.user_regular_data.querySelectorAll(".checkelement").forEach(element => {
                element.required = true;
            });
            this.check.account.allow = false;
            // Login or not registered tab
            this.login = true;
        },
        prepareIRecipient() {
            this.requiredFieldsIRecipient();
            // Set data from recipient
            this.setRecepientContacts(this.user);
        },
        requiredFieldsIRecipient() {
            this.$refs.recipient.querySelectorAll(".checkelement").forEach(element => {
                element.required = false;
            });
        },
        requiredFieldsOtherRecipient() {
            if (this.order.i_recipient) {
                this.$refs.recipient.querySelectorAll(".checkelement").forEach(element => {
                    let name = element.getAttribute("name");
                    if (name == 'recipient_user_email') {
                        element.required = false;
                    } else {
                        element.required = true;
                    }
                });

                // Remove data from recipient
                let data = {
                    fname: null,
                    name: null,
                    mname: null,
                    phone: null,
                    email: null
                }
                this.setRecepientContacts(data);
            }
        },
        setProducts() {
            let products = this.$store.state.cart.products;
            let pruducts_data = this.$store.state.cart.data;
            let array = [];
            products.forEach(product => {
                let data = pruducts_data.filter(obj => obj.product == product.id);
                array.push({
                    product_code: product.code,
                    product_price: product.price,
                    product_sale: product.sale,
                    product_qty: data[0].count
                });
            });
            this.order.products = array;
        },
        removeErrorClass(e) {
            let element = e.target.closest('.label-field');
            if (element && !element.classList.contains('error-data')) {
                element.classList.remove('error');
                return;
            }
            // For radio
            let element_radio_group = e.target.closest('.radio-amount');
            if (element_radio_group) {
                let elements = element_radio_group.querySelectorAll('.label-radio');
                for (var i = 0; i < elements.length; i++) {
                    elements[i].classList.remove('error');
                }
                return;
            }
        },
        closeSpoler(event) {
            let panel = event.target.closest('.checkout-crossing-panel');
            if (!this.validateFields(panel)) {
                let spoiler = panel.previousElementSibling;
                setTimeout(function(){
                    panel.classList.add('crossing-panel-visible');
                    spoiler.classList.add('hidden'); 
                }, 0);
            }
        },
        validateFields(search_area = this.$refs.checkoutForm) {

            let to_view = [];
            let error = false;       
                 
            // Check fields
            let inputs = search_area.querySelectorAll('.checkelement, .checkelement-no-required');

            for (var i = 0; i < inputs.length; i++) {
                
                let element = inputs[i].closest('.label-field, .label-radio');
                // Remove previous errrors
                if (element) {
                    // If not NP element
                    if (!element.classList.contains('np-field')) {
                        element.classList.remove('error');
                    }
                }

                if (inputs[i].hasAttribute('required') && (!inputs[i].value || inputs[i].type == 'radio')) {
                    // Check delivery method
                    if (inputs[i].name == 'delivery' && this.order.delivery.delivery_type) continue;
                    if (inputs[i].name == 'payment' && this.order.payment.payment_type) continue;

                    element.classList.add('error');
                    to_view.push(element);
                    error = true;
                }
                if (inputs[i].hasAttribute('validate') && inputs[i].getAttribute('validate') == 'false') {
                    let element = inputs[i].closest('.label-field');
                    element.classList.add('error');
                }
            }

            
            if(['courier_kyiv', 'kyiv_region', 'pickup'].includes(this.order.delivery.delivery_type)) {
                if(!this.order.delivery.delivery_data.delivery_date) {
                    let dateSelectorElement = document.querySelector('.dateselector');
                    if(dateSelectorElement) {
                        to_view.push(dateSelectorElement);
                        error = true;
                        this.check.delivery_date.error = true;
                    }
                }
                if(!this.order.delivery.delivery_data.delivery_time_interval) {
                    let datetimeSelectorElement = document.querySelector('.datetimeselector');
                    if(datetimeSelectorElement) {
                        to_view.push(datetimeSelectorElement);
                        error = true;
                        this.check.delivery_time_interval.error = true;
                    }
                }
            }
           
            // Open all panel with error
            for (var i = 0; i < to_view.length; i++) {
                let panel_button = to_view[i].closest('.panel-with-inputs');
                if (panel_button && !panel_button.closest('.blocked')) {
                    panel_button.previousElementSibling.click();
                }
            }
            
            // Search error in allready seted inputs
            let errors_input_blocks = search_area.querySelectorAll('.error, .warning');
            if (errors_input_blocks.length > 0) {
                error = true;
                let error_warning = search_area.querySelector('.error, .warning');
                if (error_warning) {
                    to_view.push(error_warning);
                }
            }

            // Simulate input on phone element for see error if it exists
            let event = document.createEvent('Event');
            event.initEvent('input', true, true);
            document.querySelectorAll('.vti__input').forEach(element => {
                element.dispatchEvent(event);
            });

            if (error) {
                // Find first open block
                setTimeout(
                    () => {
                        to_view[0].scrollIntoView({behavior: "smooth", block: "center", inline: "center"})
                    }
                , 150);
                console.log('error');
                return false;
            } else {
                return true;
            }
        },
        async confirmOrder(e) {
            e.preventDefault();
            
            // Check Date Time Ranges
            if (this.order.delivery.delivery_data.delivery_date) {
                const products_ids = this.$store.state.cart.products.map(product => product.id);
                await this.getAllowedDeliveryDatesTimes(true);
            }

            if (this.validateFields() && this.allowConfirm) {
                this.setProducts();
                // Set recipient user if checked i_recipeint
                if (this.order.i_recipient) {
                    this.setRecepientContacts(this.user);
                }
                this.saveInDB();
            }
        },
        liqpay_request(summ, order_id) {
            // TODO get and send data order_id
            axios({
                method: "post",
                url: window.globalVariables.locale + "/get-order-payment-form",
                data: {
                    summ: summ,
                    order_id: order_id,
                },
                config: {
                    headers: {
                        'content-type': 'multipart/form-data'
                    }
                }
            })
            .then(response => {
                let lc = document.createElement('span');
                lc.innerHTML = response.data;
                lc.setAttribute('hidden', 'true');
                lc.setAttribute('id', 'lc');
                if (document.getElementById('lc')) {
                    document.getElementById('lc').remove() 
                }
                document.body.appendChild(lc);
                lc.querySelector('form').submit();
            })
            .catch(error => {
                console.log(error);
            });
        },
        saveInDB() {
            if (this.allowRequest) {
                document.getElementById('checkout').classList.add('loading');
                this.allowRequest = false;
                axios({
                    method: "post",
                    url: window.globalVariables.locale + "/new_order",
                    data: {
                        new_user_data: this.new_user_data,
                        order: this.order,
                        cart_id: this.$store.state.cart.id,
                        products: this.$store.state.cart.data,
                        kiev_delivery: this.kiev_delivery,
                        gift: this.gift,
                        counted_vue_price: this.cost
                    },
                    config: {
                        headers: {
                            'content-type': 'multipart/form-data'
                        }
                    }
                })
                .then(response => {
                    this.unsetCookie('cart');
                    //console.log(response.data.summ, response.data.order_id);
                    if (this.order.payment.payment_type == 'liqpay') {
                        console.log(response);
                        this.liqpay_request(response.data.summ, response.data.order_id);
                    } else {
                        location.replace('/thank-you.html?order-id=' + response.data.order_id);
                    }
                })
                .catch(error => {
                    console.log(error);
                    this.allowRequest = true;
                });
            }
        },
        checkPromocode() {
            clearTimeout(window.send);
            if (this.order.promocode_number.length > 0) {
                window.send = setTimeout(()=>{
                    axios({
                        method: "post",
                        url: window.globalVariables.locale + "/promocodes/check_promocode",
                        data: {
                            promocode: this.order.promocode_number,
                            user_id:  this.order.user
                        }
                    }).then(response => {
                        this.promocode = response.data;
                    });
                }, 800);
            } else {
                this.promocode = {};
            }
        },
        checkDelivery(array) {
            if (array.includes(this.order.delivery.delivery_type)) {
                return true;
            }
        },

        async getAllowedDeliveryDatesTimes(checkUpdateRange = false) {
            const delivery_type = this.order.delivery.delivery_type;
            const products_ids = this.$store.state.cart.products.map(product => product.id);
            
            this.deliveryLoading = true;
            try {
                if (delivery_type) {
                    const response = await axios.post(`${window.globalVariables.locale}/delivery/allowed-range`, {
                        delivery_type: delivery_type,
                        products_ids: products_ids,
                    });
                
                    if (JSON.stringify(this.deliveryAllowedTimes) !== JSON.stringify(response.data.times)) {
                        if (checkUpdateRange) {
                            this.order.delivery.delivery_data.delivery_date = null;
                            this.check.delivery.error = true;
                        }
                    }
                    this.deliveryAllowedTimes = response.data.times;
                    this.deliveryDefault = response.data.default; // If not exists rules
                    this.deliveryNotAllCanBeDelivered = response.data.not_all_can_be_delivered;
                    this.deliveryLoading = false;
                } else {
                    this.deliveryAllowedDates = {};
                    this.deliveryAllowedTimes = {};
                    this.deliveryDefault = false;
                    this.deliveryLoading = false;
                }
            } catch (error) {
                console.error("Error in Dates Times:", error);
            }
        }
    }
}
</script>
